var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGhgAnnual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "matrix(-1 0 0 1 48 0)",
    fill: "#E7FCFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.375 18.625C27.375 20.155 26.4785 21.6408 25.4365 22.8261C24.9296 23.4026 24.4201 23.872 24.0367 24.1971C24.0244 24.2076 24.0121 24.218 24 24.2282C23.9879 24.218 23.9756 24.2076 23.9633 24.1971C23.5799 23.872 23.0704 23.4026 22.5635 22.8261C21.5215 21.6408 20.625 20.155 20.625 18.625C20.625 17.095 21.5215 15.6092 22.5635 14.4239C23.0704 13.8474 23.5799 13.378 23.9633 13.0529C23.9756 13.0424 23.9879 13.032 24 13.0218C24.0121 13.032 24.0244 13.0424 24.0367 13.0529C24.4201 13.378 24.9296 13.8474 25.4365 14.4239C26.4785 15.6092 27.375 17.095 27.375 18.625Z",
    stroke: "#14C6BB",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0938 27.003C31.298 27.7988 30.0845 28.1482 28.937 28.2668C28.503 28.3117 28.1027 28.321 27.7761 28.3155C27.7706 27.9889 27.7799 27.5886 27.8248 27.1546C27.9434 26.0071 28.2927 24.7936 29.0886 23.9978C29.8845 23.2019 31.0979 22.8526 32.2454 22.734C32.6794 22.6891 33.0797 22.6798 33.4064 22.6852C33.4118 23.0119 33.4025 23.4122 33.3576 23.8462C33.239 24.9937 32.8897 26.2071 32.0938 27.003ZM33.3566 21.8767L33.3567 21.8778L33.3567 21.8773L33.3566 21.8767Z",
    stroke: "#14C6BB",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9636 27.0027C15.1678 26.2068 14.8184 24.9934 14.6998 23.8459C14.655 23.4119 14.6456 23.0116 14.6511 22.6849C14.9778 22.6795 15.378 22.6888 15.812 22.7337C16.9596 22.8523 18.173 23.2016 18.9688 23.9975C19.7647 24.7933 20.114 26.0067 20.2326 27.1543C20.2775 27.5883 20.2868 27.9885 20.2814 28.3152C19.9547 28.3207 19.5544 28.3113 19.1204 28.2665C17.9729 28.1479 16.7595 27.7985 15.9636 27.0027ZM21.0899 28.2654L21.0888 28.2656L21.0893 28.2655L21.0899 28.2654Z",
    stroke: "#14C6BB",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.875V33",
    stroke: "#14C6BB",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0625 33.3125L19.9375 33.3125",
    stroke: "#14C6BB",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhgAnnual);
export default __webpack_public_path__ + "static/media/ghg-annual.d3ca6f1eccdf20f67a75dd45e57ef268.svg";
export { ForwardRef as ReactComponent };